import {BusinessProcess} from './businessProcess.model';
import {State} from './state.model';
import {User} from '../user/user.model';
import {Grouping} from './grouping.model';

export class GenericFilter {
  BusinessProcess: BusinessProcess;
  State: State;
  User: User;
  Grouping: Grouping;
  CalulateType: number;
  PeriodFrom: string;
  PeriodTo: string;
  GroupingSplit: boolean;
}
